import { Button } from "primereact/button";
import { useEffect, useState } from "react";

interface PromoConfig {
  status: boolean;
  days: number; // 或者 string，取决于你 json 里写的是什么
}
export default function Slogan() {
  const [trail,setTrail]=useState(false);
  const [trailDays,setTraiDays]=useState('');
  useEffect(() => {
    fetch('/promotion.json')
    .then(res => res.json() as Promise<PromoConfig>) 
    .then(chkTrail => {
      if(chkTrail.status){
        setTrail(true);
        setTraiDays(`Start ${chkTrail.days}-Days Free Trial`); 
      }else{
        setTrail(true);
        setTraiDays("Explore Now");
      }    
    })
    .catch(() => setTraiDays("Explore Now"));
  }, []);

  const scrollToId = (id: string) => {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50); // 延迟，确保页面渲染完成
  };
  return (
    <section
      id="slogan"
      className="section center"
      style={{ paddingTop: "2rem", paddingBottom: "2rem" }}
    >
      <h1 className="hero-title">
        <span
          style={{
            display: "block",
            fontSize: "0.70em",
            fontWeight: 500,
            color: "#666",
            marginBottom: "0.2em",
          }}
        >
          Turn your data into
        </span>

        <span
          style={{
            display: "block",
            fontWeight: 800,
            letterSpacing: "-0.03em",
          }}
        >
          Symbolic Intelligence
        </span>
      </h1>

      <p
        style={{
          fontSize: "1.5rem",
          fontWeight: 500,
          color: "#444",
          maxWidth: "900px",
          margin: "24px auto 12px",
          lineHeight: 1.5,
        }}
      >
        Predict outcomes, extract knowledge, and simulate scenarios
        instantly
      </p>

      <p
        style={{
          fontSize: "1.3rem",
          fontWeight: 400,
          color: "#888",
          marginTop: "12px",
        }}
      >
        Powered by Next-Gen Tabular AI with Deep Symbolic Learning
      </p>
      {trail&&(
          <Button
          style={{"marginTop":"30px"}}
          label= {trailDays}
          size="large"          
          onClick={() => scrollToId("download")}
        />

      )}
    </section>
  );
}
